<template>
  <div class="big">
    <div class="page_title">平台义诊活动管理（医）</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="text-align: right; margin-bottom: 12px">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="AddFree"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('734') : false
            "
          >新增义诊活动</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="free_id"
              label="活动ID"
            ></el-table-column>
            <el-table-column
              prop="start_time"
              label="义诊开始时间"
            ></el-table-column>
            <el-table-column
              prop="end_time"
              label="名额作废时间"
            ></el-table-column>
            <el-table-column
              prop="number"
              label="义诊名额"
            ></el-table-column>
            <el-table-column
              prop="doctor_num"
              label="已参与医生数"
            ></el-table-column>
            <el-table-column label="义诊数量">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.people_num"
                  style="
                    color: #669961;
                    cursor: pointer;
                    text-decoration: underline;
                  "
                  @click="toList(scope.row.free_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('736')
                      : false
                  "
                >
                  {{ scope.row.people_num }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="free_url"
              label="活动链接"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="EditFree(scope.row)"
                  type="text"
                  size="medium"
                  v-if="!scope.row.over_time"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('734')
                      : false
                  "
                >编辑</el-button>
                <el-button
                  @click="addUrl(scope.row.free_id)"
                  type="text"
                  size="medium"
                  v-if="!scope.row.over_time"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('735')
                      : false
                  "
                >添加链接</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="add_free"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="myform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="义诊开始时间"
            prop="start_time"
          >
            <el-date-picker
              v-model="ruleForm.start_time"
              type="datetime"
              style="width: 220px"
              format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>
            <div class="dialabel">患者在此时间后，向医生发起免费咨询</div>
          </el-form-item>
          <el-form-item
            label="名额作废时间"
            prop="end_hour"
            style="margin: 40px 0"
          >
            <el-select
              v-model="ruleForm.end_hour"
              placeholder="请选择"
              style="width: 220px"
            >
              <el-option
                v-for="item in end_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="dialabel">
              若患者未在义诊发起后的指定时间内使用，则名额作废
            </div>
          </el-form-item>
          <el-form-item
            label="活动名额"
            prop="number"
          >
            <el-select
              v-model="ruleForm.number"
              placeholder="请选择"
              style="width: 220px"
            >
              <el-option
                v-for="item in 10"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <div class="dialabel">义诊活动时间范围内，允许咨询人数上限</div>
          </el-form-item>
        </el-form>
      </div>
      <div style="height: 1px; background-color: #d9dadd; margin: 40px 0 20px"></div>
      <div style="text-align: center; padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            plain
            @click="add_free = false"
            style="width: 92px"
            size="medium"
          >关闭</el-button>
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
          >保存</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      add_free: false,
      title: '新增义诊活动',
      edit: false,
      end_list: [
        {
          value: 6,
          label: '6小时'
        },
        {
          value: 12,
          label: '12小时'
        },
        {
          value: 18,
          label: '18小时'
        },
        {
          value: 24,
          label: '24小时'
        }
      ],
      ruleForm: {
        start_time: '',
        end_time: '',
        number: ''
      },
      rules: {
        start_time: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        end_hour: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        number: [{ required: true, message: ' ', trigger: 'blur' }]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/Activity/getFreeConsultActivity', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.start_time = dayjs
                .unix(item.start_time)
                .format('YYYY-MM-DD HH:mm');
              item.end_time = dayjs
                .unix(item.end_time)
                .format('YYYY-MM-DD HH:mm');
              let now = dayjs(new Date()).format('YYYY-MM-DD HH:mm');
              item.over_time = false;
              if (now > item.start_time) {
                item.over_time = true;
              }
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //添加按钮
    AddFree() {
      this.title = '新增义诊活动';
      this.edit = false;
      this.ruleForm = {
        start_time: '',
        end_hour: '',
        number: ''
      };
      this.add_free = true;
    },
    //编辑按钮
    EditFree(row) {
      this.title = '编辑义诊活动';
      this.edit = true;
      let differ_time =
        (Date.parse(row.end_time) - Date.parse(row.start_time)) / 3600000;
      this.ruleForm = {
        free_id: row.free_id,
        start_time: row.start_time,
        end_hour: differ_time,
        number: row.number
      };
      this.add_free = true;
    },
    //添加义诊
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let second = Date.parse(this.ruleForm.start_time) / 1000;
          let end_stamp = second + this.ruleForm.end_hour * 60 * 60;
          let end_time = dayjs.unix(end_stamp).format('YYYY-MM-DD HH:mm');
          let data = {
            start_time: dayjs(this.ruleForm.start_time).format(
              'YYYY-MM-DD HH:mm'
            ),
            end_time: end_time,
            number: this.ruleForm.number,
            free_id: this.ruleForm.free_id ? this.ruleForm.free_id : ''
          };
          this.axios
            .post('platform/Activity/saveFreeConsultActivity', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('保存成功');
                this.add_free = false;
                this.getList();
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //详情
    toDetail(doctor_id) {
      this.$router.push({
        path: 'doctordetail',
        query: { doctor_id }
      });
    },
    //锁定解锁
    addUrl(free_id) {
      this.$prompt('请输入链接地址', '添加链接', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          let data = {
            free_id,
            free_url: value
          };
          this.axios
            .post('platform/Activity/addFreeConsultActivityUrl', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('保存成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //点击申请单去审核列表
    toList(free_id) {
      this.$router.push({
        path: 'freelist',
        query: {
          free_id
        }
      });
    }
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  text-align: left;
  padding-top: 20px;
  margin-bottom: 20px;
}
.dialabel {
  margin-top: -10px;
  color: #ff7440;
}
</style>
<style lang="scss">
.nomargin .el-form-item {
  margin-bottom: 18px;
}
</style>